"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setReferralInfo = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
const setReferralInfo = (tenant, voucherName, isInternationalShareAndEarn) => {
  if (!voucherName || !tenant) {
    return;
  }
  let referral = '';
  if (voucherName.charAt(2) === '-' || !isInternationalShareAndEarn) {
    referral = voucherName;
  } else {
    referral = `${tenant.toUpperCase()}-${voucherName}`;
  }
  _jsCookie.default.set(_presentationUtils.PbsCookieNames.PBS_OWNER, referral);
  (0, _presentationUtils.ensureQueryParameter)('store', referral);
};
exports.setReferralInfo = setReferralInfo;
//# sourceMappingURL=setReferralInfo.js.map